import { useMemo, useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

export const usePharmacyUrlParam = () => {
  const navigate = useNavigate()
  const location = useLocation()

  // URLパラメータから直接pharmacyIdを取得(派生状態として扱う)
  const pharmacyId = useMemo(() => {
    const queryParams = new URLSearchParams(location.search)
    return queryParams.get('pharmacy_id') || ''
  }, [location.search])

  const updatePharmacyParam = useCallback(
    (id: string) => {
      const queryParams = new URLSearchParams(location.search)
      if (id) {
        queryParams.set('pharmacy_id', id)
      } else {
        queryParams.delete('pharmacy_id')
      }
      const newSearch = queryParams.toString()
      const newPath = newSearch
        ? `${location.pathname}?${newSearch}`
        : location.pathname

      // 現在のパスと異なる場合のみpush
      const currentPath = location.pathname + location.search
      if (newPath !== currentPath) {
        navigate(newPath)
      }
    },
    [location.search, location.pathname, navigate]
  )

  return { pharmacyId, updatePharmacyParam }
}
